module.exports = __webpack_public_path__ + "img/music-file.a1273284.png";